module.exports = __webpack_public_path__ + "assets/img/example5.d5ab942b.jpg";